export const TipoNotificacao = {
  Sucesso: 1,
  Alerta: 2,
  Erro: 3,
};
